var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"240"}},[_c('LineChart',{style:(_vm.style),attrs:{"id":'device-history-chart-' + _vm.event.name,"data":_vm.data,"options":_vm.deviceEventHistoryChartOptions.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }